<template>
  <div class="content-box">
    <HconTitle subTitle="1:1 문의" subDescription="Hcon 사이트 이용 및 모바일 쿠폰 서비스 관련 문의를 남겨주시면 신속하게 답변드리겠습니다." />      
    <div class="sub-wrapper block">
      <div class="border-title title">
        <p class="title flex al-c">1:1 문의 내역<span class="ml12 text-gray02 fs16 font-normal bar">등록된 문의처리 상태를 목록에서 확인할 수 있습니다.</span></p>
        <div class="button-box">
          <div class="">
            <NuxtLink to="/pc/inquiry/register" class="btn">문의하기</NuxtLink>
          </div>
        </div>
      </div>
      <div class="mt80 ta-c">
        <div class="form-box inline-block w-auto">
          <div class="form-group row">
            <HconInput type="search" label="검색어" v-model="inqTitle" :hide-label="false" labelClass="mn-wd60 fs16 ta-l" inpWrapClass="wd400" inputClass="lg" placeholder="제목으로 검색해주세요." @searchBtnClick="handleSearch" />
          </div>
        </div>
      </div>
      <div class="contents-title-wrap mt40 button">
        <div class="contents-title">
          <h4 class="font-bold">총 <span class="text-green">{{ totalData }}</span>건</h4>
        </div>
        <div class="rgt-area">
          <HconDropDown type="dropdownBox" :dropdownOptions="dropDownRowPerPage" selectBoxTitleClass="counter ml8" v-model="stringRowPerPage" />
        </div>
      </div>
      <div class="table-box qna">
        <table class="tbl-type">
          <caption>1대1문의내역 관련 표</caption>
          <colgroup>
            <col style="width:6%;">
            <col style="width:14%;">
            <col style="width:10.5%;">
            <col />
            <col style="width:12%;">
          </colgroup>
          <thead>
            <tr>
              <th scope="col" class="small">No</th>
              <th scope="col" class="small">문의일시</th>
              <th scope="col" class="small">문의유형</th>
              <th scope="col" class="small">문의제목</th>
              <th scope="col" class="small">진행상태</th>
            </tr>
          </thead>
          <tbody v-if="inquiryList.length > 0">
            <tr v-for="(data, index) in inquiryList" :key="index">
              <td class="medium number">{{ totalData - (currentPage - 1) * rowPerPage - index }}</td>
              <td class="medium inquiry-date">{{ HconCommonUtils.format.dateTimeNoSec(data.inqDate) }}</td>
              <td class="medium inquiry-type">{{ data.inqType }}</td>
              <td class="medium left title">
                <NuxtLink :to="String(data.link)" class="link-underline">{{ data.title }}</NuxtLink>
              </td>
              <td class="medium">
                <p class="status" :class="data.inqStatus === '답변완료' || data.inqStatus === '추가답변' ? 'green' : 'gray'">{{ data.inqStatus }}</p>
                <p class="complate-date">{{ HconCommonUtils.format.dateTimeNoSec(data.ansDate) }}</p>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" class="nodata">1:1 문의 내역이 없습니다.</td>
            </tr>
          </tbody>
        </table>
        <HconPagnation :max-page="totalPage" :current-page="currentPage" @update:currentPage="handlePagination"/>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import HconTitle from '@/components/com/HconComPCTitle.vue'
import HconInput from '@/components/com/HconComPCInputField.vue'
import HconDropDown from '@/components/com/HconComPCDropDown.vue';
import HconPagnation from '@/components/com/HconComPCPagination.vue';
import type { Inquiry } from '@/types/inquiry/backend-dto-types'

const fetchBuilder  = useHconFetchBuilder();
const inqList = ref<Inquiry[]>([]);
const inqTitle = ref('');
const {
  showAlert,
  showConfirm,
} = usePopup();

// 1. 페이지네이션 매핑대상 변수 준비
const currentPage = ref<number>(1);  // 페이징 번호
const rowPerPage  = ref<number>(20);  // 페이징 건수 : default - 20개씩 보기
const totalData   = ref<number>(0);  // 총 데이터 건수

const totalPage = computed (() => {  // 총 페이지 건수(계산식)
  if (inqList.value.length === 0) return 0;

  // 실제 데이터 개수로 페이지 계산
  return Math.ceil(totalData.value / rowPerPage.value);
});

// 2. 페이지네이션 클릭이벤트 핸들링 함수
const handlePagination = (pageNum: number) => {
  // 2.1. 숫자 클릭 시, 현재페이지를 새값으로 바꾸고 API호출
  currentPage.value = pageNum; 
  getInqList();
}

// 추가기능1: 건수변경 드롭다운이 있을 경우, v-model 연결 및 API 즉시호출
const stringRowPerPage = computed({
  get: () => String(rowPerPage.value),
  set: (newVal: string) => {
    rowPerPage.value = Number(newVal);
    if(typeof currentPage !== 'undefined') {
      currentPage.value = 1;
    }
    getInqList();
  }
})

const dropDownRowPerPage = [ // 페이징건수
    {key: '20', value: '20개씩 보기'}
  , {key: '40', value: '40개씩 보기'}
  , {key: '100', value: '100개씩 보기'}
];

const searchParams = computed(() => {
  const pageSize = currentPage.value === 1 ? 
    rowPerPage.value : 
    rowPerPage.value;
  
  return {
    inqTitle: inqTitle.value,
    pageNum: currentPage.value,
    pageSize: pageSize
  };
});

const getInqList = async () => {
  inqList.value = []; // No 계산 초기화
  fetchBuilder.get<TableDataInfo<Inquiry>>('/api/v1/inquiry/list')
    .query(searchParams.value)
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode != '200') {
        showAlert(result.resultMessage);
        inqList.value = [];
        totalData.value = 0;
      } else {
        // ref 형식 변수에 값 즉시 세팅
        inqList.value = result.data || [];
        // 페이지네이션 처리
        totalData.value = result.total || 0;
      }
  });
}

// 검색
const handleSearch = () => {
  // 검색 시 1페이지로 리셋
  currentPage.value = 1;
  getInqList();
}

// 1:1문의 타입
interface InquiryData {
  inqId: number,
  inqType: string,
  inqStatus: string,
  title: string,
  link: string,
  inqDate: string,
  ansDate?: string,
}

const inquiryList = computed<InquiryData[]>(() => {
  const mapped = inqList.value.map((item) => {
    return {
      inqId: item.inqId,
      inqType: item.hcInqTypCd,
      inqStatus: item.hcInqStCd,
      title: item.inqTitle,
      link: `/pc/inquiry/detail/${item.inqId}`,
      inqDate: item.inqDtm,
      ansDate: item.ansDtm
    };
  });
  return mapped;
});

onMounted(() => {
  getInqList();
});

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/cs-hcon.scss" as *;

</style>